
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-card/redemption",
      function () {
        return require("private-next-pages/gift-card/redemption.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-card/redemption"])
      });
    }
  